// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"2efb5520","239":"955cff67","247":"d1cccb9d","453":"9c15d7e1","455":"cfecf670","538":"3d7c2e7d","627":"1885c3b3","653":"e94d6daa","738":"44b4e8f0","768":"8f2d5a66","834":"9eacaeb9","923":"dc04f546","938":"0d94fff7","977":"4402aa05"}[chunkId] + ".chunk.js";
};